import {useSelector} from "react-redux";
import * as THREE from "three";
import Wnd from "./Wnd";
import Door from "./Door";
//import store from '../Redux/store';
class Link{
    constructor(node1,node2){

        this.a = node1;
        this.b = node2;
        this.h = 20; //5~50
        this.height = 270;//150~350
        //this.h = Math.ceil(5+Math.random(Date.now())*45); //5~50
        this.isLink = true;
        this.leftSide = window.materials.wall[0];
        this.rightSide = window.materials.wall[0];
        //this.height = Math.ceil(150+Math.random(Date.now())*200);//150~350
        //this.side1 = useSelector(state=>state.materials.activeWallMaterial.clone());
        //this.side2 = useSelector(state=>state.materials.activeWallMaterial.clone());

        this.objects = []
    }
    equals(l){
        return (l.a === this.a && l.b === this.b) || (l.a === this.b && l.b === this.a);
    }
    length(){
        return this.a.clone().sub(this.b).length();
    }
    isHover(point){
        return point.distanceToLink(this)<=this.h/2;
    }
    canAddObject(type){
        let obj = null
        if (type === 'door') {
            obj = new Door()
        }
        if (type === 'window') {
            obj = new Wnd()
        }
        if (obj) {
            let pos = -1
            let start = 0
            let end = this.length()
            let length = end - start
            const needWidth = obj.width + (obj.padding * 2)

            this.objects.sort((a, b) => a.pos - b.pos)

            for (let i=0; i < this.objects.length; i++) {
                const _obj = this.objects[i]
                length = _obj.pos - start
                if (length >= needWidth) {
                    return true
                }
                if (i < this.objects.length-1) {
                    length = this.objects[i+1].pos - (_obj.pos + _obj.width)
                    if (length >= needWidth) {
                        return true
                    }
                } else {
                    length = end - (_obj.pos + _obj.width)
                    if (length >= needWidth) {
                        return true
                    }
                }
                start = _obj.pos + _obj.width
            }
            if (pos === -1 && length >= needWidth) {
                return true
            }
        }
        return false
    }
    addObject(type){
        let obj = null
        if (type === 'door') {
            obj = new Door()
        }
        if (type === 'window') {
            obj = new Wnd()
        }
        if (obj) {
            let pos = -1
            let start = 0
            let end = this.length()
            let length = end - start
            const needWidth = obj.width + (obj.padding * 2)

            this.objects.sort((a, b) => a.pos - b.pos)

            for (let i=0; i < this.objects.length; i++) {
                const _obj = this.objects[i]
                length = _obj.pos - start
                if (length >= needWidth) {
                    pos = start + obj.padding
                    break
                }
                if (i < this.objects.length-1) {
                    length = this.objects[i+1].pos - (_obj.pos + _obj.width)
                    if (length >= needWidth) {
                        pos = _obj.pos + _obj.width + obj.padding
                        break
                    }
                } else {
                    length = end - (_obj.pos + _obj.width)
                    if (length >= needWidth) {
                        pos = _obj.pos + _obj.width + obj.padding
                        break
                    }
                }
                start = _obj.pos + _obj.width
            }
            if (pos === -1 && length >= needWidth) {
                pos = start + obj.padding
            }
            obj.pos = pos
            const objectsByType = this.objects.filter(__obj => {
                if (
                    (type === 'door' && __obj.isDoor) ||
                    (type === 'window' && __obj.isWindow)
                ) {
                    return true
                } else {
                    return false
                }
            })
            obj.id = objectsByType.length + 1
            this.objects.push(obj)
        }
        return this.objects
    }
    removeObject(id){
        this.objects = this.objects.filter((obj, index) => index !== id)
    }
};

export default Link;
